module.exports = "<div>\n    <button class=\"btn-select form-control\" value=\"\" [disabled]=\"disabled\">\n        <div class=\"select-thumbnail-input\"></div>\n        <div class=\"select-thumbnail-carret\">\n            <i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i>\n        </div>\n    </button>\n    <div class=\"select-list-wrapper\">\n        <ul #selectList class=\"select-thumbnail-list\">\n        </ul>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/select-thumbnail/select-thumbnail.component.html
// module id = ./src/app/shared/components/select-thumbnail/select-thumbnail.component.html
// module chunks = main